import "./Navbar.module.css";

const Navbar = () => {
  return (
    <nav>
      <h2>Covid19 Tracker</h2>
    </nav>
  );
};

export default Navbar;